import React, { useCallback, useEffect, useState } from "react";
import { AlertTriangle, ChevronDown, ChevronUp, X } from "lucide-react";
import { API_BASE_URL } from "src/config/apiBase";
import { decryptToken } from "../utils/getToken";

const SEVERITY_CLASS = {
  high: "crm-anomaly__item--high",
  medium: "crm-anomaly__item--medium",
  low: "crm-anomaly__item--low",
};

const CrmAnomalyAlerts = ({ slaMinutes = 15, onOpenLead }) => {
  const [data, setData] = useState(null);
  const [expanded, setExpanded] = useState(true);
  const [dismissed, setDismissed] = useState(false);
  const url = API_BASE_URL;
  const token = decryptToken("accessToken") || "";

  const load = useCallback(() => {
    fetch(`${url}/leads/crm-anomalies?slaMinutes=${slaMinutes}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((res) => {
        if (res) setData(res);
      })
      .catch(() => {});
  }, [url, token, slaMinutes]);

  useEffect(() => {
    load();
    const interval = setInterval(load, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, [load]);

  if (dismissed || !data?.alerts?.length) return null;

  const highCount = data.alerts.filter((a) => a.severity === "high").length;

  return (
    <div className="crm-anomaly">
      <div className="crm-anomaly__head">
        <div className="crm-anomaly__title">
          <AlertTriangle size={18} />
          <strong>
            {data.count} alert{data.count !== 1 ? "s" : ""}
            {highCount > 0 ? ` · ${highCount} urgent` : ""}
          </strong>
        </div>
        <div className="crm-anomaly__actions">
          <button type="button" onClick={() => setExpanded((v) => !v)} aria-label="Toggle alerts">
            {expanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
          </button>
          <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss alerts">
            <X size={16} />
          </button>
        </div>
      </div>

      {expanded && (
        <ul className="crm-anomaly__list">
          {data.alerts.map((alert) => (
            <li
              key={alert.id}
              className={`crm-anomaly__item ${SEVERITY_CLASS[alert.severity] || ""}`}
            >
              <div>
                <strong>{alert.title}</strong>
                <p>{alert.message}</p>
              </div>
              {alert.leadId && onOpenLead && (
                <button type="button" onClick={() => onOpenLead(alert.leadId)}>
                  View
                </button>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CrmAnomalyAlerts;
